var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteConfirm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30523",
    "data-name": "Group 30523",
    transform: "translate(-154 -288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    transform: "translate(154 288)",
    fill: "none",
    stroke: "#fc0b06",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 33,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30329",
    "data-name": "Group 30329",
    transform: "translate(181.427 314.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30276",
    "data-name": "Group 30276"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4238",
    "data-name": "Path 4238",
    d: "M16.963,31.252H11.628l-1.612-8.521h8.558Z",
    transform: "translate(-8.223 -18.661)",
    fill: "none",
    stroke: "#2e4341",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4239",
    "data-name": "Path 4239",
    d: "M14.257,15.147V13.732H3.29v1.5",
    transform: "translate(-2.701 -11.273)",
    fill: "none",
    stroke: "#2e4341",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_69",
    "data-name": "Line 69",
    y1: 1.852,
    transform: "translate(6.073 0.589)",
    fill: "none",
    stroke: "#2e4341",
    strokeLinecap: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteConfirm);
export default __webpack_public_path__ + "static/media/delete_confirm.f075cca155d243a0ae6bca7472643661.svg";
export { ForwardRef as ReactComponent };